import axios, { AxiosError } from 'axios'

/**
 * Extracts an error message sent from the API or
 * reads message string from any Error class instance (can be both axios network or JS error)
 */
export const extractErrorMessage = (error: AxiosError<{ errorMessage?: string }>): string => {
  return (axios.isAxiosError(error) && error.response?.data?.errorMessage) || error.message
}

/**
 * create a encrypt based on the ruby code we have on data_layer_variables
 * @param email - user email
 * @returns
 */
export const encryptEmail = async (email: string) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(email)
  const hashBuffer = await crypto.subtle.digest('SHA-1', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
  return hashHex
}
